"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("../../Compositions/Modal/Modal"));
var _Button = require("../../Elements/Button/Button");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgressPage = ({
  onHide,
  show,
  children,
  header,
  footer,
  size,
  isRtl,
  closeLabelValue,
  showConfirmOnClose,
  confirmTitle,
  confirmDescription,
  confirmAcceptButtonText,
  confirmRejectButtonText
}) => {
  const [showConfirm, setShowConfirm] = (0, _react.useState)(false);
  const handleHide = () => {
    if (showConfirmOnClose) {
      setShowConfirm(true);
      return false;
    }
    onHide == null || onHide();
  };
  const handleHideAll = () => {
    if (showConfirmOnClose) {
      setShowConfirm(false);
    }
    onHide == null || onHide();
  };
  const cssModifier = 'ccl-progress-page';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
      fullscreen: true,
      show: show,
      onHide: handleHide,
      size: size,
      isRtl: isRtl,
      bsPrefix: `${cssModifier} modal ${(header == null ? void 0 : header()) !== undefined && 'use-header'}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Header, {
        closeButton: (header == null ? void 0 : header()) == undefined ? true : false,
        closeLabelValue: (header == null ? void 0 : header()) == undefined ? closeLabelValue : undefined,
        children: (header == null ? void 0 : header()) !== undefined && header(handleHide)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Body, {
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Footer, {
        children: (footer == null ? void 0 : footer()) !== undefined && footer()
      })]
    }), showConfirmOnClose && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default, {
      show: showConfirm,
      dialogClassName: "modal-confirm",
      backdropClassName: "modal-backdrop-confirm",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Header, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Title, {
          children: confirmTitle
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default.Body, {
        children: confirmDescription
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.default.Footer, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          text: confirmRejectButtonText,
          onClick: () => setShowConfirm(false),
          variant: "secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          text: confirmAcceptButtonText,
          onClick: handleHideAll
        })]
      })]
    })]
  });
};
var _default = exports.default = ProgressPage;
module.exports = exports.default;